import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getAllSuppliers,
	getSupplierConsolidationFilters,
	updateTailTopShift,
	getSpendShiftData,
	getUpdatedStatus,
	getDistrictFilterForExport,
} from "../../queries/apiQueries";
import { Button, Loader, SelectPicker, Modal } from "rsuite";
import "./supplierConsolidation.scss";
import CategoryOverview from "./categoryOverview";
import SpendShift from "./spendShift";
import { FILTERDATA, TIMELINE, CURRENTVIEW } from "../../utils";
import {  projectType } from "../constants";
import { Label } from "recharts";
import { appInsights } from "../router";
import MainHeader from "../../components/Layouts/MainHeader";
import { Segmented } from "antd";
import MainContent from "../../components/Layouts/MainContent";
import { getTimelineOptions } from "../../config/constants";

const SupplierConsolidation = (props: any) => {
	const timelineOptions=getTimelineOptions()
	const dispatch = useDispatch<any>();
	const [filtersLoading, setFiltersLoading] = useState(true);
	const [buttonEnabled, setButtonEnabled] = useState(false);
	const [actionSaved, setActionSaved] = useState(false);
	const [alert, setAlert] = useState(false);
	const [suppliersList, setSuppliersList] = useState<Array<any>>([]);
	const [backupSuppliersList, setBackupSuppliersList] = useState<any>([]);
	const [isVisible, setIsVisible] = useState(false);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const token = useSelector((state: any) => state.CommonReducer.token);
	const timeline = useSelector((state: any) => state.CommonReducer.timeline);
	const [updateSuplierData, setUpdateSuplierData] = useState<any>([]);

	//spendShift state variables
	const [spendConsolidationList, setSpendConsolidationList] = useState<any>(
		[]
	);
	const [topSuppliersList, setTopSuppliersList] = useState<Array<any>>([]);
	const [overSpendMsg, setOverSpendMsg] = useState(false);
	const [kpi, setKPI] = useState<any>(null);
	const [scenario, setScenario] = useState<any>("base");
	const [popUp, setPopUp] = useState(false);

	const [backupSpendShift, setBackupSpendShift] = useState<any>(null);

	const scenarioOptions = [
		{ label: "Base Scenario", value: "base" },
		{ label: "Saved Scenario", value: "saved" },
	];

	const [selectedProjectType, setSelectedProjectType] = useState(
		projectType.length && projectType[2].value
	);

	const [scenarioSelected, setScenarioSeleceted] = useState<any>(null);
	const [lastUpdated, setLastUpdated] = useState<any>(null);

	const modalScenarioOptions = [
		"Scenario 1",
		"Scenario 2",
		"Scenario 3",
		"Scenario 4",
		"Scenario 5",
	].map((item) => ({ label: item, value: item }));

	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : getTimelineOptions()[0]?.value
	);

	const [isLoading, setIsLoading] = useState(true);
	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
	});
	const [districtfilterOptions, setDistrictfilterOptions] = useState<any>({
		district: new Array<{ district: string }>(),
	});
	const [selectedDistrictFilter, setSelectedDistrictFilter] =
		useState<any>(null);

	const [selectedFilters, setSelectedFilters] = useState<any>(allFilters);
	const [tableLoading, setTableLoading] = useState(false);
	const [page, setPage] = useState("overall");
	const didMount: any = useRef(false);
	const filtersMount: any = useRef(false);
	const segmentOptions = [
		{ label: "Category Overview", value: "overall" },
		{ label: "Spend Shift", value: "categoryLevel" },
		{ label: "Supplier Proposal", value: "proposalLevel" },
		{ label: "Saving Model Data", value: "savingModel" },
	];
	const showSubmitResetButtons: boolean =
		buttonEnabled && (updateSuplierData?.length ?? 0) > 0;

	const showSaveScenarioButton: boolean =
		page !== "overall" &&
		page !== "proposalLevel" &&
		page !== "savingModel" &&
		selectedFilters.l3.length > 0;

	const isChartFlexTall: boolean =
		showSubmitResetButtons || showSaveScenarioButton;

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to supplier consolidation by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (token) {
			getFilters();
		}
	}, [token]);
	useEffect(() => {
		props.onTimelineChange(selectedTimeline);
		if (token) {
			if (selectedTimeline && selectedFilters.l3.length == 1) {
				getSpendShift();
				getSuppliers();
			}
		}
	}, [selectedTimeline]);

	useEffect(() => {
		if (token) {
			if (selectedProjectType && selectedFilters.l3.length == 1) {
				getSpendShift();
				getSuppliers();
			}
		}
	}, [selectedProjectType]);

	useEffect(() => {
		if (token) {
			if (scenarioSelected !== null && selectedFilters.l3.length == 1) {
				getSpendShift();
				getSuppliers();
			}
		}
	}, [scenarioSelected]);

	const getSuppliers = async (scenarioType: any = null) => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			scenario: scenarioType ? scenarioType : scenario,
			timeline: selectedTimeline,
			projectType: selectedProjectType,
		};
		let res = await dispatch(getAllSuppliers(payload));

		setBackupSuppliersList(JSON.parse(JSON.stringify(res.data)));
		setSuppliersList(res.data);
		// setIsLoading(false);
	};

	const getUpdatedInfo = async (loadingKey: boolean = false) => {
		if (!loadingKey) {
			setIsLoading(true);
		}
		let payload = {
			l3: selectedFilters.l3,
			projectType: selectedProjectType,
		};
		let res = await dispatch(getUpdatedStatus(payload));

		if (res.data.length > 0) {
			setScenario("saved");
			getSuppliers("saved");
			getSpendShift("saved");
			setScenarioSeleceted("saved");
			setLastUpdated(res?.data[0]?.updatedBy);
		} else {
			getSuppliers();
			getSpendShift();
			setLastUpdated(null);
		}
		filtersMount.current = false;
	};

	const getSpendShift = async (scenarioType: any = null) => {
		setActionSaved(false);
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			scenario: scenarioType ? scenarioType : scenario,
			timeline: selectedTimeline,
			projectType: selectedProjectType,
		};
		try {
			let res = await dispatch(getSpendShiftData(payload));
			let topSuppliers: any = [];
			if (res?.charts) {
				res.charts.map((item: any) => {
					topSuppliers = [...topSuppliers, item.master_vendor_name];
				});
				setTopSuppliersList(topSuppliers);
			}
			if (res.tableData) {
				// let topSuppliers: any = [];
				// Object.keys(res.tableData[0]).map((item: any) => {
				//   if (
				//     item !== "tail_end_supplier" &&
				//     item !== "spend" &&
				//     item !== "remainingSpend" &&
				//     item !== "editable" &&
				//     item !== "sumOfSuppliers"
				//   ) {
				//     topSuppliers = [...topSuppliers, item];
				//   }
				// });

				// setTopSuppliersList(topSuppliers);

				res.tableData = res.tableData.map((d: any, key: any) => {
					let sumOfTopSuppliers = topSuppliers.reduce(
						(acc: any, curr: any) => {
							return Number((acc + d[curr]).toFixed(2));
						},
						0
					);

					console.log(sumOfTopSuppliers, "sumOfTopSuppliers");

					d["remainingSpend"] =
						sumOfTopSuppliers > 1 ? 0 : 1 - sumOfTopSuppliers;
					d["sumOfSuppliers"] = sumOfTopSuppliers;
					d["editable"] = false;
					return d;
				});
			}
			setOverSpendMsg(
				!res.tableData.every((d: any) => d.remainingSpend >= 0)
			);
			setSpendConsolidationList(res.tableData);
			setKPI(res);
			setBackupSpendShift(JSON.parse(JSON.stringify(res)));
			setIsLoading(false);
		} catch (error) {
			console.log(error);
		}

		setIsLoading(false);
	};

	const updateSpendShift = async (data: any) => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			timeline: selectedTimeline,
			projectType: selectedProjectType,
			scenario: scenario,
			tableData: data,
		};
		let res = await dispatch(getSpendShiftData(payload));
		if (res) {
			setKPI({ ...res });
			setActionSaved(true);
		}
	};

	const updateSupplierDistribution = async () => {
		setIsLoading(true);
		let username = localStorage.getItem("user_name");
		const payload = {
			...selectedFilters,
			data: updateSuplierData,
			projectType: selectedProjectType,
		};

		let res = await dispatch(updateTailTopShift(payload));
		getSpendShift("saved");
		setScenario("saved");
		setPage("categoryLevel");
		setIsLoading(false);
		setUpdateSuplierData([]);
	};

	console.log(updateSuplierData, "upadte");

	const handleUpdateData = (data: any) => {
		let updateSuplierDataCopy = JSON.parse(
			JSON.stringify(updateSuplierData)
		);
		let dataCopy = data;
		let index = updateSuplierDataCopy?.findIndex(
			(e: any) => e.master_vendor_name === data?.master_vendor_name
		);
		if (index !== -1) {
			updateSuplierDataCopy?.splice(index, 1);
		} else {
			dataCopy.previousSavedTopSupplierFlag = dataCopy?.isTopSupplier;
			updateSuplierDataCopy?.push(dataCopy);
		}

		setUpdateSuplierData(updateSuplierDataCopy);
	};

	const getDistrictForExport = async (item: any) => {
		let payload: any = {
			master_vendor_name: [item],
		};
		let res = await dispatch(getDistrictFilterForExport(payload));
		if (res) {
			setDistrictfilterOptions({ district: res });
		}
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		// setFiltersLoading(true);
		if (Object.keys(payload).length > 0) {
			payload.projectType = selectedProjectType;
		}
		let res = await dispatch(getSupplierConsolidationFilters(payload));
		if (fo) {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...fo });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		} else {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...filterOptions });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		}

		setIsLoading(false);
		setFiltersLoading(false);
		filtersMount.current = false;
		return res;
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		filtersMount.current = true;
		let x: string = filter;
		setSelectedFilters({ ...selectedFilters, [x]: [value] });
		selectedFilters[x] = [value];
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "l1") {
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [] });
			getFilters({ ...selectedFilters, l2: [], l3: [] }, "l1");
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [] });
			getFilters({ ...selectedFilters, l3: [] }, "l2");
		} else if (filter === "l3") {
			// setIsLoading(true);
			setSelectedFilters({ ...selectedFilters });
			if (selectedFilters.l3.length == 1) {
				getUpdatedInfo();
				//   getSuppliers();
				//   getSpendShift();
			}
		}
	};

	useEffect(() => {
		if (token) {
			if (!didMount.current) {
				setIsLoading(true);
				getFilters().then((options: any) => {
					if (selectedFilters.l3.length > 0) {
						getFilters(selectedFilters, "l3", options);
						getUpdatedInfo(true);
					} else if (selectedFilters.l2.length > 0) {
						getFilters(selectedFilters, "l2", options);
					} else if (selectedFilters.l1.length > 0) {
						getFilters(selectedFilters, "l1", options);
					}
				});
				// getSummaryData();
				didMount.current = true;
				getSuppliers();
				getSpendShift();
			} else {
				props.onFilterChange(selectedFilters);
			}
		}
	}, [selectedFilters]);

	const handleAlertClose = () => setAlert(false);
	const handlePopUpClose = () => setPopUp(false);

	const handleAlertConfirmClick = () => {
		setPage("categoryLevel");
		setButtonEnabled(false);
		setAlert(false);
	};

	const handlePopUpConfirmClick = () => {
		setPopUp(false);
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	/* on changing project type */
	const projectTypeHandler = (e: any) => {
		setSelectedProjectType(e === null ? "All" : e);
	};

	return isLoading ? (
		<Loader size="md" inverse center content="loading..." />
	) : (
		<>
			<Modal
				backdrop={true}
				role="alertdialog"
				open={alert}
				onClose={handleAlertClose}
				size="xs"
			>
				<Modal.Body>
					Any unsaved changes will be lost. Are you sure, you want to
					continue?
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={handleAlertConfirmClick}
						className="modal-yes-btn"
					>
						Yes, Continue
					</Button>
					<Button
						onClick={handleAlertClose}
						className="modal-close-btn"
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal
				backdrop={true}
				role="alertdialog"
				open={popUp}
				onClose={handlePopUpClose}
				size="xs"
			>
				<Modal.Body>
					<div className=" modal-scenario-select" key="scenario">
						<span className="italic"> Save scenario as</span>
						<SelectPicker
							data={modalScenarioOptions}
							disabled={buttonEnabled}
							value={
								scenario
									? scenario
									: modalScenarioOptions[0].value
							}
							cleanable={false}
							onChange={(value: any) => {
								setScenario(value);
							}}
							loading={filtersLoading}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer className="scenario-modal-footer">
					<Button
						onClick={handlePopUpConfirmClick}
						className="modal-save-btn"
					>
						Save
					</Button>
				</Modal.Footer>
			</Modal>
			<div className="supplier-consolidation-container w-full">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<>
							<div className="flex justify-between items-center w-full">
								<div className="text-left pageline">
									<span className="pagelinestart">
										Sourcing and Strategic Supplier
										Negotiations
									</span>{" "}
									<span className="pagelineslash">/</span>{" "}
									<span className="pagelinesub">
										Supplier Consolidation
									</span>
								</div>
							</div>
							<div className="execution-level-wrapper">
								<div className="execution-level-title">
									View By
								</div>
								<Segmented
									options={segmentOptions}
									value={page}
									onChange={(val) => {
										if (
											val === "categoryLevel" &&
											buttonEnabled
										) {
											setAlert(true);
										} else {
											setPage(val);
										}
									}}
								/>
							</div>
						</>
					}
					bottomContent={
						<>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">Timeline</span>
								<SelectPicker
									data={
										timelineOptions.length
											? timelineOptions
											: []
									}
									placeholder="All"
									value={selectedTimeline}
									defaultValue={
										timelineOptions.length
											? timelineOptions[0].value
											: ""
									}
									onChange={timelineHandler}
									cleanable={false}
								/>
							</div>
							{["l1", "l2", "l3"].map(
								(filterEntity: string, index: number) => {
									return (
										<div className="sub-heading-text font-bold flex flex-col items-start">
											<span className="filterHead ">
												{filterEntity}
											</span>
											<SelectPicker
												data={
													filterOptions[filterEntity]
														.length
														? filterOptions[
																filterEntity
														  ]
														: []
												}
												disabled={buttonEnabled}
												labelKey={
													filterEntity == "supplier"
														? "vendor"
														: filterEntity
												}
												valueKey={
													filterEntity == "supplier"
														? "vendor"
														: filterEntity
												}
												value={
													selectedFilters[
														filterEntity
													]
														? selectedFilters[
																filterEntity
														  ][0]
														: []
												}
												cleanable={false}
												onClose={() =>
													filtersMount.current
														? handleClose(
																filterEntity
														  )
														: ""
												}
												onChange={(value: any) => {
													handleFilterUpdate(
														value,
														filterEntity
													);
												}}
												loading={filtersLoading}
											/>
										</div>
									);
								}
							)}
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">scenario</span>
								<SelectPicker
									data={scenarioOptions}
									disabled={buttonEnabled}
									value={
										scenario
											? scenario
											: scenarioOptions[0].value
									}
									cleanable={false}
									onChange={(value: any) => {
										setScenario(value);
										setScenarioSeleceted(value);
									}}
									loading={filtersLoading}
								/>
							</div>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">
									Project Type
								</span>
								<SelectPicker
									data={projectType.length ? projectType : []}
									placeholder="All"
									value={selectedProjectType}
									defaultValue={
										projectType.length
											? projectType[0].value
											: ""
									}
									onChange={projectTypeHandler}
									cleanable={false}
								/>
							</div>
						</>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					<div
						className={`chart-flex ${
							isChartFlexTall ? "!h-[90%] mb-2" : ""
						}`}
					>
						{page === "overall" ||
						page === "proposalLevel" ||
						page === "savingModel" ? (
							<CategoryOverview
								data={suppliersList}
								tableLoading={tableLoading}
								l3={selectedFilters.l3}
								selectedFilters={selectedFilters}
								selectedProjectType={selectedProjectType}
								page={page}
								shiftSuppliers={(item: any) => {
									handleUpdateData(item);
									setSuppliersList(
										suppliersList.map((supplier: any) => {
											if (
												supplier.master_vendor_name ==
												item.master_vendor_name
											) {
												supplier.isTopSupplier =
													supplier.isTopSupplier == 0
														? 1
														: 0;
												supplier.updatedBy =
													localStorage.getItem(
														"user_name"
													);
											}
											return supplier;
										})
									);
								}}
								updateButtonEnabled={(item: any) => {
									setButtonEnabled(item);
								}}
								handleButtonClick={(item: any) => {
									getDistrictForExport(item);
								}}
								districtfilterOptions={districtfilterOptions}
								selectedDistrictFilter={selectedDistrictFilter}
								updateSelectedDistrictFilter={(item: any) => {
									setSelectedDistrictFilter(item);
								}}
							/>
						) : (
							<SpendShift
								data={spendConsolidationList}
								tableLoading={tableLoading}
								l3={selectedFilters.l3}
								topSuppliersList={topSuppliersList}
								handleChange={(
									e: any,
									oldValue: any,
									obj: any,
									rowIndex: any,
									editedTopSupplier: any
								) => {
									let diff =
										Number(e.target.value) / 100 - oldValue;
									let newSum = Number(
										obj.sumOfSuppliers + diff
									);
									let remainingSpendTemp = 1 - newSum;
									let res = spendConsolidationList;
									res[rowIndex][editedTopSupplier] =
										Number(e.target.value) / 100;
									res[rowIndex].remainingSpend =
										remainingSpendTemp;
									res[rowIndex].sumOfSuppliers = newSum;
									setSpendConsolidationList([...res]);
									setOverSpendMsg(
										!res.every(
											(d: any) => d.remainingSpend >= 0
										)
									);
								}}
								handleSave={(obj: any, index: any) => {
									if (Object.keys(obj)?.length > 0) {
										//  backupSpendShift.tableData[index] = obj;
										updateSpendShift([obj]);
									}
								}}
								handleReset={(obj: any, index: any) => {
									if (Object.keys(obj)?.length > 0) {
										spendConsolidationList[index] =
											JSON.parse(
												JSON.stringify(
													backupSpendShift.tableData[
														index
													]
												)
											);
										setOverSpendMsg(
											!spendConsolidationList.every(
												(d: any) =>
													d.remainingSpend >= 0
											)
										);
									}
								}}
								overSpendMsg={overSpendMsg}
								kpiData={kpi}
							/>
						)}
					</div>
					{buttonEnabled && updateSuplierData?.length > 0 && (
						<div>
							<button
								className="savingButton"
								onClick={() => {
									updateSupplierDistribution();
									setButtonEnabled(false);
								}}
							>
								Submit Changes
							</button>
							<button
								className="resetingButton ml-2"
								onClick={() => {
									setSuppliersList(
										JSON.parse(
											JSON.stringify(backupSuppliersList)
										)
									);
									setButtonEnabled(false);
								}}
							>
								Reset
							</button>
						</div>
					)}
					{page !== "overall" &&
						page !== "proposalLevel" &&
						page !== "savingModel" &&
						selectedFilters.l3.length > 0 && (
							<div>
								<button
									className="savingButton"
									onClick={() => {
										// setPopUp(true);
										if (actionSaved) {
											setScenario("saved");
											setScenarioSeleceted("saved");
										}
									}}
								>
									Save Scenario
								</button>
							</div>
						)}
				</MainContent>
			</div>
		</>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => {
		dispatch({ type: FILTERDATA, data: data });
		dispatch({
			type: CURRENTVIEW,
			data: {
				isSummaryView: true,
				viewBy: "Supplier",
				selectedHighlight: null,
				filters: {
					district: [],
					l1: [],
					l2: [],
					l3: [],
					supplier: [],
				},
			},
		});
	},
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});
export default connect(null, mapDispatchToProps)(SupplierConsolidation);
